import { render, staticRenderFns } from "./index.vue?vue&type=template&id=029ce646"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src724620054/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('029ce646')) {
      api.createRecord('029ce646', component.options)
    } else {
      api.reload('029ce646', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=029ce646", function () {
      api.rerender('029ce646', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Stores/Editor/Redemptions/index.vue"
export default component.exports